// @flow

const dashboard = {
  active: true,
  label: 'Dashboard',
  onChangeUpdate: false,
  parentIsList: true,
  isList: false,
  idRequired: true,
  show: false,
  component: 'shared/dashboard/Dashboard'
};

export default dashboard;
